module.exports = __webpack_public_path__ + "static/media/unionpay.ee9cb307.svg";